/* ==========================================================================
   Renew Records — Tiered free gift popup
   Paired with sections/freegift-popup.liquid + assets/component-free-gift.css

   Rules implemented:
     - Lower tiers  : unlocked + selectable
     - Current tier : unlocked + selectable, badged "Jouw tier"
     - Higher tiers : visible but locked ("Spend X more to unlock these gifts")
     - Exactly ONE free gift per order
     - Live "spend X more" amount, recalculated from the real cart
   ========================================================================== */

(function () {
  'use strict';

  var CHECKOUT_FLAG = 'renewrecords_gift_checkout';
  var SELECTION_KEY = 'renewrecords_gift_selection';

  var root = document.getElementById('rr-gift-modal');
  var configEl = document.getElementById('rr-gift-config');
  if (!root || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var strings = config.strings || {};

  /* -------------------------------------------------------- money helpers */

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';

    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents) {
    var format = config.moneyFormat || '€{{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return format;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return format.replace(placeholder, value);
  }

  // Money without cents when they are ".00" — matches the €250 scale labels.
  function formatMoneyShort(cents) {
    return cents % 100 === 0
      ? formatMoney(cents).replace(/([.,])00\b/, '')
      : formatMoney(cents);
  }

  function interpolate(template, replacements) {
    return String(template || '').replace(/\{(\w+)\}/g, function (whole, key) {
      return Object.prototype.hasOwnProperty.call(replacements, key) ? replacements[key] : whole;
    });
  }

  function bold(text) {
    return '<b>' + text + '</b>';
  }

  // Below 750px each string may have a "<key>Mobile" override; a blank
  // override falls back to the desktop copy.
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function copy(key) {
    var override = strings[key + 'Mobile'];
    return mobileQuery.matches && override ? override : strings[key];
  }

  /* ------------------------------------------------------------- elements */

  var els = {
    title: root.querySelector('[data-rr-gift-title]'),
    subtitle: root.querySelector('[data-rr-gift-subtitle]'),
    message: root.querySelector('[data-rr-gift-message]'),
    count: root.querySelector('[data-rr-gift-count]'),
    fill: root.querySelector('[data-rr-gift-fill]'),
    sections: Array.prototype.slice.call(root.querySelectorAll('[data-rr-gift-tier]')),
    body: root.querySelector('.rr-gift__body'),
    nudge: root.querySelector('[data-rr-gift-nudge]'),
    nudgeText: root.querySelector('[data-rr-gift-nudge-text]'),
    confirm: root.querySelector('[data-rr-gift-confirm]'),
    error: root.querySelector('[data-rr-gift-error]')
  };

  /* ---------------------------------------------------------------- state */

  // Tiers sorted ascending by threshold, so the "next tier" maths is
  // order-safe even if blocks get re-ordered in the theme editor.
  var tiers = (config.tiers || []).slice().sort(function (a, b) {
    return a.from - b.from;
  });

  var giftProductIds = (config.giftProductIds || []).map(Number);

  // Shopify Markets serves /cart.js totals in the PRESENTMENT currency, while
  // the tier thresholds are entered in the shop currency. Without converting,
  // an INR cart (rate ~113) clears every euro threshold instantly.
  var currencyRate = 1;
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
    var parsed = parseFloat(window.Shopify.currency.rate);
    if (parsed > 0) currencyRate = parsed;
  }

  if (currencyRate !== 1) {
    tiers.forEach(function (tier) {
      tier.from = Math.round(tier.from * currencyRate);
      tier.to = Math.round(tier.to * currencyRate);
    });
  }

  var maxThreshold = tiers.length ? tiers[tiers.length - 1].from : 0;

  // Re-label the tier headings and scale ticks in the converted currency,
  // unless the merchant typed a label by hand.
  function relabelForCurrency() {
    if (currencyRate === 1) return;

    tiers.forEach(function (tier, i) {
      if (!tier.labelOverride) {
        tier.label = i === tiers.length - 1
          ? formatMoneyShort(tier.from) + '+'
          : formatMoneyShort(tier.from) + ' – ' + formatMoneyShort(tier.to);
      }

      var node = sectionFor(tier.index);
      var nameEl = node && node.querySelector('[data-rr-gift-tier-name]');
      if (nameEl) {
        nameEl.textContent = (strings.tierPrefix ? strings.tierPrefix + ' ' : '') + tier.label;
      }

      var tick = root.querySelector('[data-rr-gift-tick="' + tier.index + '"]');
      if (tick) tick.textContent = formatMoneyShort(tier.from);
    });
  }
  var eligibleTotal = Number(config.initialTotal) || 0;
  var isAddingGift = false;
  var lastFocused = null;

  function sectionFor(index) {
    return els.sections.filter(function (node) {
      return Number(node.dataset.rrGiftTier) === index;
    })[0];
  }

  // Design order: the customer's own tier first, then the lower tiers they may
  // also pick from (descending), then the locked ones ascending as upsell.
  // Mirrors the mockup's
  //   tiers.slice(0, cur + 1).reverse().concat(tiers.slice(cur + 1))
  function orderTiers() {
    if (!els.body) return;

    var curIdx = -1;
    tiers.forEach(function (tier, i) {
      if (isUnlocked(tier)) curIdx = i;
    });

    tiers.slice(0, curIdx + 1).reverse()
      .concat(tiers.slice(curIdx + 1))
      .forEach(function (tier) {
        var node = sectionFor(tier.index);
        if (node) els.body.appendChild(node);
      });
  }

  function isUnlocked(tier) {
    return !!tier && eligibleTotal >= tier.from;
  }

  function nextLockedTier() {
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].from > eligibleTotal) return tiers[i];
    }
    return null;
  }

  function highestUnlockedTier() {
    var found = null;
    tiers.forEach(function (tier) {
      if (isUnlocked(tier)) found = tier;
    });
    return found;
  }

  function selectedInput() {
    return root.querySelector('input[name="free-gift"]:checked');
  }

  function inputByValue(value) {
    return root.querySelector('input[name="free-gift"][value="' + String(value).replace(/"/g, '') + '"]');
  }

  // localStorage so the choice survives closing the tab, not just a refresh.
  function saveSelection() {
    try {
      var input = selectedInput();
      if (input) localStorage.setItem(SELECTION_KEY, input.value);
      else localStorage.removeItem(SELECTION_KEY);
    } catch (error) {
      /* private mode */
    }
  }

  function clearSavedSelection() {
    try { localStorage.removeItem(SELECTION_KEY); } catch (error) {}
  }

  // Re-apply the remembered gift after a reload — but only while it is still
  // unlocked and in stock, otherwise forget it.
  function restoreSelection() {
    if (selectedInput()) return;

    var saved;
    try { saved = localStorage.getItem(SELECTION_KEY); } catch (error) { return; }
    if (!saved) return;

    var input = inputByValue(saved);
    if (!input || input.disabled) {
      clearSavedSelection();
      return;
    }
    input.checked = true;
  }

  /* ------------------------------------------------------------ rendering */

  function renderHeader() {
    var totalLabel = bold(formatMoney(eligibleTotal));

    if (els.title) els.title.textContent = copy('title');

    if (els.subtitle) {
      els.subtitle.innerHTML = interpolate(copy('subtitle'), { total: totalLabel });
    }

    var next = nextLockedTier();

    if (els.message) {
      els.message.innerHTML = next
        ? interpolate(copy('spendMore'), {
            amount: bold(formatMoney(next.from - eligibleTotal)),
            tier: next.label
          })
        : copy('allUnlocked');
    }

    // Target the tier they are working towards, not the very top one.
    if (els.count) {
      els.count.textContent = interpolate(strings.progressCount, {
        total: formatMoney(eligibleTotal),
        max: formatMoneyShort(next ? next.from : maxThreshold)
      });
    }
  }

  // One continuous fill across the whole track: cart / highest tier.
  function renderProgress() {
    if (!els.fill) return;

    var pct = maxThreshold > 0 ? (eligibleTotal / maxThreshold) * 100 : 0;
    els.fill.style.width = Math.min(100, Math.max(0, pct)) + '%';
  }

  // Per-tier heading badge, locked notice and card states.
  function renderTiers() {
    var current = highestUnlockedTier();

    tiers.forEach(function (tier) {
      var node = sectionFor(tier.index);
      if (!node) return;

      var unlocked = isUnlocked(tier);
      var missing = tier.from - eligibleTotal;
      var head = node.querySelector('[data-rr-gift-tier-head]');
      var lock = node.querySelector('[data-rr-gift-tier-lock]');
      var badge = node.querySelector('[data-rr-gift-tier-badge]');
      var msg = node.querySelector('[data-rr-gift-tier-msg]');
      var cta = node.querySelector('[data-rr-gift-tier-cta]');

      node.classList.toggle('rr-gift__tier--locked', !unlocked);
      if (head) head.classList.toggle('rr-gift__tier-head--locked', !unlocked);
      if (lock) lock.hidden = unlocked;

      // Locked heading carries its own "spend X more" line + top-up button,
      // so it needs no separate notice underneath.
      if (msg) {
        var isCur = unlocked && current && current.index === tier.index;
        msg.hidden = unlocked && isCur;
        if (!unlocked) {
          msg.textContent = interpolate(copy('tierLocked'), { amount: formatMoney(missing) });
        } else if (!isCur) {
          msg.textContent = copy('lowerTierHint');
        }
      }

      if (cta) {
        cta.hidden = unlocked;
        if (!unlocked) {
          cta.textContent = interpolate(copy('tierCta'), { amount: formatMoney(missing) });
        }
      }

      // Current tier gets the solid "Jouw tier" pill; already-unlocked lower
      // tiers get the soft "Ook beschikbaar" one.
      if (badge) {
        var isCurrent = unlocked && current && current.index === tier.index;
        var isLower = unlocked && !isCurrent;

        badge.hidden = !unlocked;
        badge.classList.toggle('rr-gift__tier-badge--lower', isLower);
        if (isCurrent) badge.textContent = strings.yourTier;
        else if (isLower) badge.textContent = strings.lowerTier;
      }

      node.querySelectorAll('[data-rr-gift-card]').forEach(function (card) {
        var input = card.querySelector('input[name="free-gift"]');

        card.classList.toggle('rr-gift__card--locked', !unlocked);

        if (input) {
          // A gift that sold out stays unavailable no matter what the tier
          // state says — re-rendering must not hand it back.
          var soldOut = card.classList.contains('rr-gift__card--soldout');
          input.disabled = !unlocked || soldOut;
          // A gift that just became locked (cart edited in another tab) must
          // not stay selected.
          // Cart dropped below this tier again, or the gift sold out — drop
          // the choice with it.
          if (input.disabled && input.checked) {
            input.checked = false;
            clearSavedSelection();
          }
        }
      });
    });

    restoreSelection();
    syncSelection();
  }

  // Sticky footer banner: always the next-tier upsell, hidden once every
  // tier is unlocked. Locked tiers carry their own inline notice.
  function renderNudge() {
    if (!els.nudge || !els.nudgeText) return;

    var next = nextLockedTier();
    if (!next) {
      els.nudge.hidden = true;
      return;
    }

    els.nudge.hidden = false;
    els.nudgeText.innerHTML = interpolate(copy('nudge'), {
      amount: bold(formatMoney(next.from - eligibleTotal)),
      count: next.count,
      tier: next.label
    });
  }

  function syncSelection() {
    root.querySelectorAll('[data-rr-gift-card]').forEach(function (card) {
      var input = card.querySelector('input[name="free-gift"]');
      card.classList.toggle('is-selected', !!input && input.checked);
    });

    if (els.confirm) {
      var hasSelection = !!selectedInput();
      els.confirm.disabled = !hasSelection;
      els.confirm.textContent = hasSelection
        ? interpolate(strings.confirm, { price: formatMoney(0) })
        : strings.confirmEmpty;
    }
  }

  function render() {
    renderHeader();
    renderProgress();
    orderTiers();
    renderTiers();
    renderNudge();
  }

  /* ------------------------------------------------------------ cart data */

  // Shopify guarantees routes.root has a trailing slash ("/" or "/nl/"), so
  // localised storefronts keep working.
  function routeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function fetchCart() {
    return fetch(routeRoot() + 'cart.js', { cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function isGiftLine(item) {
    if (item.properties && item.properties._free_gift) return true;
    return giftProductIds.indexOf(Number(item.product_id)) !== -1;
  }

  // Gift lines never count towards unlocking a tier.
  function eligibleTotalFrom(cart) {
    return cart.items.reduce(function (sum, item) {
      return isGiftLine(item) ? sum : sum + item.final_line_price;
    }, 0);
  }

  function cartHasGift(cart) {
    return cart.items.some(isGiftLine);
  }

  // Lowest tier that offers this product — the most generous reading when the
  // same gift appears in several tiers.
  function tierForProduct(productId) {
    var id = Number(productId);
    for (var i = 0; i < tiers.length; i++) {
      var ids = tiers[i].productIds || [];
      if (ids.indexOf(id) !== -1) return tiers[i];
    }
    return null;
  }

  // A gift already sitting in the cart must not survive the cart dropping below
  // the tier that earned it — or the real products being removed entirely.
  function giftLinesToDrop(cart) {
    var eligible = eligibleTotalFrom(cart);
    var hasRealItems = cart.items.some(function (item) { return !isGiftLine(item); });

    return cart.items.filter(function (item) {
      if (!isGiftLine(item)) return false;
      if (!hasRealItems) return true;

      var tier = tierForProduct(item.product_id);
      return !!tier && eligible < tier.from;
    });
  }

  // The same sections the theme's own cart re-renders, so removing a gift
  // updates the page in place instead of forcing a refresh.
  function cartSectionsToRender() {
    var list = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    if (items && items.dataset.id) {
      list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '#main-cart-items .js-contents' });
    }
    list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    list.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    if (footer && footer.dataset.id) {
      list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '#main-cart-footer .js-contents' });
    }
    return list;
  }

  function applyCartSections(state, sections) {
    if (!state || !state.sections) return;

    sections.forEach(function (entry) {
      if (!entry.section || !state.sections[entry.section]) return;

      var host = document.getElementById(entry.id);
      if (!host) return;

      try {
        var fresh = new DOMParser()
          .parseFromString(state.sections[entry.section], 'text/html')
          .querySelector(entry.selector);
        if (!fresh) return;
        (host.querySelector(entry.selector) || host).innerHTML = fresh.innerHTML;
      } catch (error) {
        /* leave the old markup in place */
      }
    });

    var empty = state.item_count === 0;
    var footer = document.getElementById('main-cart-footer');
    var custom = document.querySelector('.main-custom-cart');
    if (footer) footer.classList.toggle('is-empty', empty);
    if (custom) {
      custom.classList.toggle('is-empty', empty);
      custom.classList.toggle('main-custom-cart__layout--empty', empty);
    }
  }

  // Drops the offending gift lines and repaints the cart, no reload.
  function enforceGiftEligibility(cart) {
    if (isAddingGift) return Promise.resolve(null);

    var drop = giftLinesToDrop(cart);
    if (!drop.length) return Promise.resolve(null);

    var sections = cartSectionsToRender();
    var sectionNames = sections
      .map(function (entry) { return entry.section; })
      .filter(Boolean)
      .join(',');

    return drop
      .reduce(function (chain, item) {
        return chain.then(function () {
          return fetch(routeRoot() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
              sections: sectionNames,
              sections_url: window.location.pathname
            })
          }).then(function (response) { return response.json(); });
        });
      }, Promise.resolve())
      .then(function (state) {
        applyCartSections(state, sections);
        limitGiftQuantities();
        clearSavedSelection();
        return state;
      })
      .catch(function () { return null; });
  }

  function refreshFromCart() {
    return fetchCart()
      .then(function (cart) {
        return enforceGiftEligibility(cart).then(function (updated) {
          return updated || cart;
        });
      })
      .then(function (cart) {
        eligibleTotal = eligibleTotalFrom(cart);
        render();
        return cart;
      })
      .catch(function () {
        render();
        return null;
      });
  }

  /* --------------------------------------------------------- open + close */

  // Spinner on whichever button kicked off the wait.
  function setButtonLoading(button, on) {
    if (!button) return;
    button.classList.toggle('rr-gift-loading', !!on);
    if (on) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function goToCheckout() {
    sessionStorage.setItem(CHECKOUT_FLAG, '1');
    window.location.href = routeRoot() + 'checkout';
  }

  function openModal() {
    lastFocused = document.activeElement;

    if (root.parentElement !== document.body) document.body.appendChild(root);

    root.hidden = false;
    document.body.classList.add('free-gift-modal-open');

    render();

    // The current tier is ordered first, so the top of the list is the
    // right landing spot.
    if (els.body) {
      var previous = els.body.style.scrollBehavior;
      els.body.style.scrollBehavior = 'auto';
      els.body.scrollTop = 0;
      els.body.style.scrollBehavior = previous;
    }

    var closeBtn = root.querySelector('[data-rr-gift-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    setButtonLoading(document.querySelector('.cart__checkout-button'), false);
    root.hidden = true;
    document.body.classList.remove('free-gift-modal-open');
    if (els.error) els.error.hidden = true;
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  /* ---------------------------------------------------------- add to cart */

  function addGift() {
    if (isAddingGift) return;

    var input = selectedInput();
    if (!input || input.disabled) return;

    isAddingGift = true;
    els.confirm.disabled = true;
    els.confirm.textContent = strings.adding;
    setButtonLoading(els.confirm, true);
    if (els.error) els.error.hidden = true;

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: input.value, quantity: 1, properties: { _free_gift: 'true' } }]
      })
    })
      .then(function (response) {
        // A gift can sell out between page render and confirm; Shopify answers
        // 422 for that, and the customer must pick something else.
        if (response.status === 422) {
          var soldOut = new Error('Gift sold out');
          soldOut.soldOut = true;
          throw soldOut;
        }
        if (!response.ok) throw new Error('Add to cart failed');
        return fetchCart();
      })
      .then(function (cart) {
        if (!cartHasGift(cart)) throw new Error('Gift was not added');
        els.confirm.textContent = strings.added;
        clearSavedSelection();
        goToCheckout();
      })
      .catch(function (error) {
        isAddingGift = false;
        setButtonLoading(els.confirm, false);

        if (error && error.soldOut) {
          input.checked = false;
          input.disabled = true;
          var card = input.closest('[data-rr-gift-card]');
          if (card) card.classList.add('rr-gift__card--soldout');
          clearSavedSelection();
        }

        syncSelection();
        els.confirm.disabled = !selectedInput();

        if (els.error) {
          els.error.hidden = false;
          els.error.textContent = error && error.soldOut ? strings.soldOut : strings.addError;
        }
      });
  }

  /* ------------------------------------------------ cart-page housekeeping */

  // A gift line may only ever be quantity 1.
  function limitGiftQuantities() {
    document.querySelectorAll('.cart-item[data-product-id]').forEach(function (row) {
      if (giftProductIds.indexOf(Number(row.dataset.productId)) === -1) return;

      var input = row.querySelector('.quantity__input');
      var plus = row.querySelector('.quantity__button[name="plus"]');

      if (input) {
        input.max = 1;
        if (Number(input.value) > 1) input.value = 1;
      }
      if (plus) plus.disabled = true;
    });
  }

  function reloadCartPage() {
    var url = new URL(window.location.href);
    url.searchParams.set('cart_sync', String(Date.now()));
    window.location.replace(url.toString());
  }

  // Coming back from checkout via the bfcache leaves a stale server-rendered
  // cart on screen; re-sync when the DOM and /cart.js disagree.
  function handleCartPageReturn() {
    closeModal();

    if (sessionStorage.getItem(CHECKOUT_FLAG)) {
      sessionStorage.removeItem(CHECKOUT_FLAG);
      reloadCartPage();
      return;
    }

    // Only the cart page renders line items, and only there can the DOM be
    // stale. Without this guard a page without #main-cart-items would compare
    // 0 rows against a non-empty cart and reload forever.
    var cartItemsRoot = document.getElementById('main-cart-items');

    fetchCart()
      .then(function (cart) {
        // Try the in-place fix first: if a gift no longer qualifies we remove
        // it and repaint the cart sections, so no reload is ever needed.
        return enforceGiftEligibility(cart).then(function (updated) {
          if (updated) {
            eligibleTotal = eligibleTotalFrom(updated);
            render();
            return;
          }

          // Nothing to remove — only now check for a genuinely stale DOM
          // (browser back / bfcache showing a cached page).
          if (cartItemsRoot) {
            var domCount = cartItemsRoot.querySelectorAll('.cart-item').length;
            var giftInDom = Array.prototype.some.call(
              document.querySelectorAll('.cart-item[data-product-id]'),
              function (row) {
                return giftProductIds.indexOf(Number(row.dataset.productId)) !== -1;
              }
            );

            if ((cartHasGift(cart) && !giftInDom) || domCount !== cart.items.length) {
              reloadCartPage();
              return;
            }
          }

          eligibleTotal = eligibleTotalFrom(cart);
          render();
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------- listeners */

  document.addEventListener('click', function (event) {
    var checkoutBtn = event.target.closest('.cart__checkout-button');
    if (!checkoutBtn || checkoutBtn.disabled) return;

    if (!root.querySelector('input[name="free-gift"]')) return;

    event.preventDefault();
    setButtonLoading(checkoutBtn, true);

    refreshFromCart()
      .then(function (cart) {
        // Gift already in the cart → straight to checkout, never offer a
        // second one. Leave the spinner running, the page is navigating.
        if (cart && cartHasGift(cart)) {
          goToCheckout();
          return;
        }
        if (!highestUnlockedTier()) {
          goToCheckout();
          return;
        }
        setButtonLoading(checkoutBtn, false);
        openModal();
      })
      .catch(function () {
        setButtonLoading(checkoutBtn, false);
      });
  });

  // Locked or sold-out cards must not be selectable, even via the label.
  root.addEventListener('click', function (event) {
    var card = event.target.closest('[data-rr-gift-card]');
    if (!card) return;
    var input = card.querySelector('input[name="free-gift"]');
    if (card.classList.contains('rr-gift__card--locked') ||
        card.classList.contains('rr-gift__card--soldout') ||
        (input && input.disabled)) {
      event.preventDefault();
    }
  }, true);

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-rr-gift-overlay]') || event.target.closest('[data-rr-gift-close]')) {
      closeModal();
      return;
    }

    if (event.target.closest('[data-rr-gift-confirm]')) {
      event.preventDefault();
      addGift();
      return;
    }

    if (event.target.closest('[data-rr-gift-decline]')) {
      event.preventDefault();
      goToCheckout();
    }
  });

  root.addEventListener('change', function (event) {
    if (event.target.name !== 'free-gift') return;
    saveSelection();
    syncSelection();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) closeModal();
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', render);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(render);
  }

  window.addEventListener('pagehide', closeModal);
  window.addEventListener('pageshow', handleCartPageReturn);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      limitGiftQuantities();
      refreshFromCart();
    });
  }

  // `pageshow` also fires on the initial load, so it covers first render too.
  limitGiftQuantities();
  relabelForCurrency();
  render();
})();
